import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updatePercentagesPagination } from '../../../store/actions/percentage/percentage_action';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import { REACT_ROUTES } from '../../../constants/react_routes';
import SearchComponent from '../../ui_components/search';
import history from '../../../services/history';
import PercentagesTable from './percentages_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    alignCenter: {
        textAlign: 'center'
    }
}));

const PercentageList = ({ percentages }) => {
    const { container, alignCenter } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = percentages;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updatePercentagesPagination({...percentages, page: 0, filters: { ...filters, search }}))
    }

    const handleAddArticleClick = () => {
        history.push(REACT_ROUTES.PERCENTAGE);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Procenti usluga/radnika
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={alignCenter}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddArticleClick}
                    >
                        Kreirajte
                    </Button>
                </Grid>
                <PercentagesTable />
            </Grid>
        </Container>
    )
}

PercentageList.propTypes = {
    percentages: PropTypes.object
}

const mapStateToProps = (state) => ({
    percentages: state.percentages
});

export default connect(mapStateToProps)(PercentageList);
